import { render, staticRenderFns } from "./UpdateProductSetInfos.vue?vue&type=template&id=4780d69c&scoped=true"
import script from "./UpdateProductSetInfos.vue?vue&type=script&lang=ts"
export * from "./UpdateProductSetInfos.vue?vue&type=script&lang=ts"
import style0 from "./UpdateProductSetInfos.vue?vue&type=style&index=0&id=4780d69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780d69c",
  null
  
)

export default component.exports